import React from 'react';
import ThemeContext from './ThemeContext';
export default function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/useTheme/useTheme.js
// module id = 1726
// module chunks = 121